/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import { CallControlsVehicleFragmentDoc } from '../../../../../ad-operator-call/src/lib/components/CallControls/CallControls.hook'
import { AdPoolingToggleVehicleFragmentDoc } from '../../../../../ad-pooling-toggle/src/lib/AdPoolingToggle.hook'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type AdVehicleStreamHeaderVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  isWheelchairAccessible: boolean | null
  isSelfDriving: boolean
  label: number | null
  fccOperatorAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
    }>
  } | null
  pooling: { __typename?: 'Pooling'; enabled: boolean } | null
  fccCurrentAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename?: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
    }>
  } | null
}

export const AdVehicleStreamHeaderVehicleFragmentDoc = gql`
    fragment AdVehicleStreamHeaderVehicle on Vehicle {
  id
  isWheelchairAccessible
  isSelfDriving
  label
  fccOperatorAdAlerts {
    alerts {
      __typename
      id
      type
    }
  }
  ...AdPoolingToggleVehicle
  ...CallControlsVehicle
}
    ${AdPoolingToggleVehicleFragmentDoc}
${CallControlsVehicleFragmentDoc}`
